import { render } from "./OrgDetails.vue?vue&type=template&id=55de32a6&ts=true"
import script from "./OrgDetails.vue?vue&type=script&lang=ts"
export * from "./OrgDetails.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__